import {
  etherium2Logo,
  hardHatLogo,
  nodejsLogo,
  openZeppelinLogo,
  reactLogo,
  solidityLogo,
  web3jsLogo,
} from 'Assets/_Legacy/Technologies'

export const TECHNOLOGIES = [
  {
    id: 'tech001',
    logo: hardHatLogo,
    name: 'Hardhat',
    text: 'A modern blockchain development infrastructure with extensive testing and debugging tooling',
  },
  {
    id: 'tech002',
    logo: openZeppelinLogo,
    name: 'OpenZeppelin',
    text: 'An open-source framework for secure smart contract development.',
  },
  {
    id: 'tech003',
    logo: etherium2Logo,
    name: 'Ethereum',
    text: 'Allows developers to build and deploy decentralized applications',
  },
  {
    id: 'tech004',
    logo: nodejsLogo,
    name: 'NodeJS',
    text: 'A leading, open-source, cross-platform JavaScript run-time environment to easily build fast and scalable network applications.',
  },
  {
    id: 'tech005',
    logo: reactLogo,
    name: 'React',
    text: 'A structural front-end framework for dynamic web apps simplifies building web applications',
  },
  {
    id: 'tech006',
    logo: reactLogo,
    name: 'React Native',
    text: 'A cross-platform front-end framework for building mobile applications for iOS and Android.',
  },
  {
    id: 'tech007',
    logo: web3jsLogo,
    name: 'Web3JS',
    text: 'A collection of libraries that allow you to interact with a local or remote Ethereum node.',
  },
  {
    id: 'tech008',
    logo: solidityLogo,
    name: 'Solidity',
    text: 'A statically-typed programming language designed for developing smart contracts.',
  },
]
